import * as React from 'react'

export const THEME_KEY = 'theme'
export const HIDE_CONTACT_HEADER_KEY = 'hide-contact-header'

export const Themes = {
  DARK: 'dark',
  LIGHT: 'light',
}

export const useTheme = (initial = Themes.DARK) => {
  const [theme, setTheme] = React.useState(
    () => localStorage.getItem(THEME_KEY) || initial
  )

  React.useEffect(() => {
    localStorage.setItem(THEME_KEY, theme)
  }, [theme])

  React.useEffect(() => {
    const theme = localStorage.getItem(THEME_KEY)
    if (!!theme && typeof theme === 'string') {
      setTheme(theme)
    }
  }, [])

  return { theme, setTheme }
}
